import {
  BillsharkInfo,
  BillsharkSubmitBillResponse,
} from '@core/models/interfaces/storage-data/billshark';
import { createActionGroup, props } from '@ngrx/store';

export const BillsharkInfoActions = createActionGroup({
  source: 'BillsharkInfo',
  events: {
    'Load Billshark Info Success': props<{ billsharkInfo: BillsharkInfo }>(),
    'Add Submitted Bill': props<{
      submittedBill: BillsharkSubmitBillResponse;
    }>(),
  },
});
